import { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import api from '../lib/api';
import { Zap, CheckCircle, AlertCircle, Loader2 } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_video-forge-417/artifacts/8amlg66h_Logo%20futuriste%20de%20ViralSynth.com.png";

export default function ConfirmEmailPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Lien de confirmation invalide.');
      return;
    }
    confirmEmail();
  }, [token]);

  const confirmEmail = async () => {
    try {
      const res = await api.post('/auth/confirm-email', { token });
      setStatus('success');
      setMessage(res.data.message);
    } catch (err) {
      setStatus('error');
      setMessage(err.response?.data?.detail || 'Erreur lors de la confirmation');
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-6" data-testid="confirm-email-page">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 justify-center mb-12">
          <img src={LOGO_URL} alt="ViralSynth" className="w-64 h-auto" />
        </Link>

        <div className="card-surface rounded-lg p-8 md:p-10 text-center">
          {status === 'loading' && (
            <div data-testid="confirm-loading">
              <Loader2 className="w-12 h-12 text-white/30 mx-auto mb-4 animate-spin" />
              <h1 className="font-heading text-2xl font-medium text-white mb-2">Confirmation en cours...</h1>
              <p className="text-sm text-white/40">Veuillez patienter</p>
            </div>
          )}

          {status === 'success' && (
            <div data-testid="confirm-success">
              <CheckCircle className="w-12 h-12 text-[#34C759] mx-auto mb-4" />
              <h1 className="font-heading text-2xl font-medium text-white mb-2">Email confirme !</h1>
              <p className="text-sm text-white/40 mb-6">{message}</p>
              <Link to="/dashboard" className="btn-accent text-sm px-8 py-3 inline-block" data-testid="go-to-dashboard-btn">
                Aller au dashboard
              </Link>
            </div>
          )}

          {status === 'error' && (
            <div data-testid="confirm-error">
              <AlertCircle className="w-12 h-12 text-[#FF3B30] mx-auto mb-4" />
              <h1 className="font-heading text-2xl font-medium text-white mb-2">Erreur de confirmation</h1>
              <p className="text-sm text-white/40 mb-6">{message}</p>
              <Link to="/dashboard" className="btn-outline text-sm px-8 py-3 inline-block">
                Retour au dashboard
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
